// extracted by mini-css-extract-plugin
export default {"header":"PageHeader_header__yeUqH","breadcrumb":"PageHeader_breadcrumb__Fb56X","title":"PageHeader_title__aTwnu","subtitle":"PageHeader_subtitle__sVbH8"};